(function() {
	const collapseBtns = document.getElementsByClassName("js-collapse-btn");
	for (let i = 0; i < collapseBtns.length; i++) {
		collapseBtns[i].addEventListener("click", function() {
			const collapse = this.nextElementSibling;

			if (collapse.hasAttribute("style")) {
				collapse.removeAttribute("style");
			}
			else {
				collapse.style.height = collapse.children[0].offsetHeight + "px";
			}
		});
	}
})()